var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{ref:"view",staticClass:"goods-list"},[_vm._v("333")])])
}
var staticRenderFns = []

export { render, staticRenderFns }